import { useEffect, useCallback } from 'react';

function useKeydown(key: string, callback: Function) {
  const handleKeydown = useCallback((event: KeyboardEvent) => {
    if (event.key === key) {
      callback();
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleKeydown, false);

    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [handleKeydown]);
}

export default useKeydown;
